module.exports = __webpack_public_path__ + "img/coupon_back.ce116b94.png";